// extracted by mini-css-extract-plugin
export default {"InformationBlock_titles__subtitle":"zw4xZBdgTH9rwoJSXz9J"};